export default __webpack_public_path__ + "static/media/Ncash-smaller.f58f37ef.png";